import React from "react";
import { Box, Typography } from "@mui/material";
import { Check } from "@mui/icons-material";

interface CustomStepperProps {
  steps: any[];
  activeStep: number;
}

const RentalStepper: React.FC<CustomStepperProps> = ({ steps, activeStep }) => {
  return (
    <Box sx={styles.stepperContainer}>
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isCompleted = steps[index].id < activeStep;
        const isActive = step.id === activeStep;

        return (
          <Box key={index} sx={styles.stepContainer}>
            <Box
              sx={{
                ...styles.stepWrapper,
                backgroundColor: isActive ? "#bfd1ef" : "#ffffff",
                borderLeft: "1px solid #c4c4c4",
              }}
            >
              <Typography
                sx={{
                  ...styles.stepLabel,
                  color: isCompleted || isActive ? "#333333" : "#c4c4c4",
                  fontWeight: isCompleted || isActive ? 600 : 400,
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                {isCompleted ? <Check sx={{ color: "#64b5f6" }} /> : stepNumber} {step.label}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

const styles = {  
  stepperContainer: {
     display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#ffffff",
    margin: "4px 0px",
    borderRadius: "5px",
    overflow: "hidden"
  },
  stepContainer: {
    display: "flex",
    alignItems: "center",
    flex: 1,
  },
  stepWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    width: "100%",
    padding: "6px"
  },
  stepNumber: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: 600,
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  stepLabel: {
    fontSize: "14px",
    whiteSpace: "nowrap",
    transition: "all 0.3s ease",
  },
};

export default RentalStepper;
